<template>
    <div id="contenedor-main-listado-adjudicaciones">
        <template
            v-if="!$vuetify.breakpoint.mobile">
            <desktop :listadoAdjudicacionesDirectas="listadoAdjudicacionesDirectas"></desktop>
        </template>
        <template
            v-else>
            <mobile :listadoAdjudicacionesDirectas="listadoAdjudicacionesDirectas"></mobile>
        </template>
    </div>
</template>

<script>
import Desktop from './Desktop.vue';
import Mobile from './Mobile.vue';

export default {
  name: 'MainListadoAdjudicaciones',
  props: {
    listadoAdjudicacionesDirectas: {
      type: Array,
      required: true,
    },
  },
  components: {
    Desktop,
    Mobile,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
